import React from 'react';
import { Container } from '@material-ui/core';
import DQCompanyInfoView from './DQCompanyInfo.view';
import DQProgramInfoView from './DQProgramInfo.view';
import useStyles from '../../../../assets/styles/ProgramRatingStyles';

const DQCompanyProgramInfoView = ({ data, actions, options }) => {
    const classes = useStyles();
    const { company_data, program_data } = data;
    const { company_actions, program_actions } = actions;
    const { company_options, program_options } = options;
    const [companyInfo, setCompanyInfo] = React.useState({});

    const handleCompanyDataChange = (values) => {
        setCompanyInfo(values);
    };

    const combinedSubmitAction = (programValues) => {
        const combinedData = {
            ...companyInfo,
            ...programValues,
        };
        program_actions.submitAction(combinedData);
    };

    return (
        <Container className={classes.container}>
            <DQCompanyInfoView
                data={company_data}
                actions={{...company_actions, handleCompanyDataChange}}
                options={company_options}
            />
            <DQProgramInfoView
                data={program_data}
                actions={{ submitAction: combinedSubmitAction }}
                options={program_options}
            />
        </Container>
    );
};

export default DQCompanyProgramInfoView;